import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register chart components
ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const AdminDashboard = () => {
  const statsRecord = [
    { label: "Total Submitted", stats: "Today's stats", color: "green" },
    { label: "Total Sent", stats: "Today's stats", color: "green" },
    { label: "Total Delivered", stats: "Today's stats", color: "green" },
    { label: "Total Failed", stats: "Today's stats", color: "red" },
    { label: "Total Submitted", stats: "Last 30 days stats", color: "green" },
    { label: "Total Sent", stats: "Last 30 days stats", color: "green" },
    { label: "Total Delivered", stats: "Last 30 days stats", color: "green" },
    { label: "Total Failed", stats: "Last 30 days stats", color: "red" },
  ];

  const lineData = {
    labels: ["Submitted", "Sent", "Delivered", "Failed"],
    datasets: [
      {
        label: "Statistics",
        data: [0.5, 0.8, 0.6, 0.2],
        borderColor: "#00BFFF",
        backgroundColor: "rgba(0, 191, 255, 0.2)",
        pointBorderColor: "#00BFFF",
        pointBackgroundColor: "#fff",
        tension: 0.3,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: true },
    },
    scales: {
      y: { beginAtZero: true },
    },
  };

  return (
    <div className="marginRight flex flex-col gap-4 px-6 py-8 lg:px-20">
      {/* Breadcrumb */}
      <div className="flex items-center">
        <h1 className="text-3xl font-semibold text-gray-500">Dashboard</h1>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {statsRecord.map((item, index) => {
          const isFailed = item.color === "red";

          return (
            <div key={index}>
              <div className="flex items-center justify-between rounded bg-white p-4 border-l-[3px] border-[#00BFFF] shadow-sm">
                <div>
                  <h6 className="text-sm font-medium text-gray-500">
                    {item.label}
                  </h6>

                  <h4 className="mt-1 text-2xl font-semibold text-gray-800">
                    0
                  </h4>

                  <small
                    className={`text-sm ${
                      isFailed ? "text-red-600" : "text-green-600"
                    }`}
                  >
                    {item.stats}
                  </small>
                </div>

                <span
                  className={`rounded px-3 py-1 text-xl font-semibold ${
                    isFailed
                      ? "bg-red-100 text-red-600"
                      : "bg-green-100 text-green-700"
                  }`}
                >
                  {isFailed ? "✖" : "✔"}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      {/* Charts Section */}
      <div className="flex flex-col gap-4 lg:flex-row">
        {/* Message Volume Statistics */}
        <div className="flex-[6]">
          <div className="flex h-[300px] w-full flex-col items-center rounded bg-white p-4 border-l-[3px] border-[#00BFFF] shadow-sm">
            <h6 className="text-sm font-medium text-gray-500">
              Message Volume Statistics
            </h6>

            <div className="h-[250px] w-full">
              <Line data={lineData} options={options} />
            </div>
          </div>
        </div>

        {/* Today's Statistics */}
        <div className="flex-[3]">
          <div className="flex h-[300px] w-full flex-col items-center rounded bg-white p-4 border-l-[3px] border-[#00BFFF] shadow-sm">
            <h6 className="text-sm font-medium text-gray-500">
              Today's Statistics
            </h6>

            <div className="h-[250px] w-full">
              <Line data={lineData} options={options} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;